export const LABEL_STYLE: CSSStyleDeclaration = {
  padding: '4px',
  color: 'white',
  fontSize: '14px',
  userSelect: 'none',
} as CSSStyleDeclaration;

export const BUTTON_STYLE: CSSStyleDeclaration = {
  minWidth: '60px',
  height: '25px',
  backgroundColor: '#FFFFFF',
  userSelect: 'none',
} as CSSStyleDeclaration;

export const INPUT_STYLE: CSSStyleDeclaration = {
  width: '40px',
  height: '20px',
  fontSize: '14px',
} as CSSStyleDeclaration;

export const SECTION_LABEL_STYLE: Partial<CSSStyleDeclaration> = {
  display: 'block',
  color: 'white',
  fontSize: '17px',
  backgroundColor: 'green',
  padding: '2px 2px 2px 2px',
  marginBottom: '5px',
  minHeight: '20px',
};
